/*
payment/commonview/view_submitbtn

import view_submitbtn from ...

-- supply callback to invoke on click --
view_submitbtn.init({cb });

return:
see api

 --delete button and eventhandlers --
 view_submitbtn.close();
*/

import core from '../../common/lib/core.js';

const classnameOpen = 'u-show';
const classnameClose = 'u-hide';
const create = core.create;

function createButton(txt, eventFilter) {
	const elm = create({
		type: 'button',
		class: `${eventFilter} payment__submit-deposit btn u-b-radius`
	});
	/* txt is essential input and if it is empty throw error */
	elm.innerHTML = txt;
	return elm;
}

function deleteAllElements(elmObj) {
	return core.deleteElementsInObjectExcept(elmObj, [], 'view_submitbtn:39');
}

function show(elm) {
	if (elm) {
		core.removeClass(elm, classnameClose);
		core.addClass(elm, classnameOpen);
	}
}

function hide(elm) {
	core.removeClass(elm, classnameOpen);
	core.addClass(elm, classnameClose);
}

function clickBtnHandler(e, onClickCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		onClickCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, handler, eventFilter) {
	function handleCreator(e) {
		clickBtnHandler(e, handler, eventFilter);
	}
	core.addListener(elm, 'click', handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler) {
	if (elm) {
		core.removeListener(elm, 'click', handler);
	}
}

export default {
	create(p) {
		const buttonText = p.buttonText;
		// const classNameEventFilter = `.js-event-filter-submitbtn-${buttonText}`;
		const classNameEventFilter = 'js-event-filter-submitbtn';
		let enabled = true;
		const callbackOnSubmitBtn = function callbackOnSubmitBtn() {
			if (p && p.cb && enabled) {
				p.cb();
			}
		};
		const elements = {};
		elements.wrap = createButton(buttonText, classNameEventFilter);

		const handler = addListeners(elements.wrap, callbackOnSubmitBtn, classNameEventFilter);
		/* the button is displayed by default,
		 hide it actively from .hide() */
		show(elements.wrap);
		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			enable() {
				// execute callback on main event
				enabled = true;
				if (elements && elements.wrap) {
					elements.wrap.disabled = false;
				}
			},
			disable() {
				// do not execute callback on main event
				enabled = false;
				if (elements && elements.wrap) {
					elements.wrap.disabled = true;
				}
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler);
				deleteAllElements(elements);
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/commonview/lib/view-submitbtn.js